<template>
  <section class="page">
    <div class="page-content">
      <div class="top-image">
        <img v-show="imgShow" class="animated slideInLeft" src="@/assets/img/banner_1.png"/>
      </div>
      <div class="introduction">
        <h2 class="subtitle">实施过程</h2>
        <p class="detailed">
            1）项目规划：1.组建项目团队  
            <span class="line-letter-spacing">
              2.首次拜访交流
            </span>
            <span class="line-letter-spacing">
              3.确定实施策略与计划
            </span>
            <span class="line-letter-spacing">
              4.项目启动会
            </span>
          <br/>
            2）方案设计：1.网络及服务器部署方案
            <span class="line-letter-spacing">
              2.基础软件部署
            </span>
            <span class="line-letter-spacing">
              3.需求调研
            </span>
            <span class="line-letter-spacing">
              4.需求方案设计
            </span>
            <span class="line-letter-spacing">
              5.需求方案确认
            </span>
          <br/>
            3）系统建设： 1.定制化功能开发
            <span class="line-letter-spacing">
              2.电力自动化工程调试
            </span>
            <span class="line-letter-spacing">
              3.用户测试(UAT)环境准备
            </span>
            <span class="line-letter-spacing">
              4.用户操作手册制定发布
            </span>
            <span class="line-letter-spacing">
              5.用户测试(UAT)启动会
            </span>
            <span class="line-letter-spacing">
              6.关键用户培训
            </span>
            <span class="line-letter-spacing">
            7.用户测试(UAT)
            </span>
            <span class="line-letter-spacing">
              8.静态数据整理
            </span>
          <br/>
            4）上线准备：1.建立内部支持体系
            <span class="line-letter-spacing">
              2.系统运行制度制定和发布
            </span>
            <span class="line-letter-spacing">
              3.系统正式环境部署
            </span>
            <span class="line-letter-spacing">
              4.系统上线方案
            </span>
            <span class="line-letter-spacing">
              5.系统权限配置
            </span>
            <span class="line-letter-spacing">
              6.静态数据维护
            </span>
            <span class="line-letter-spacing">
              7.管理员和最终用户培训
            </span>
            <span class="line-letter-spacing">
              8.系统切换检查
            </span>
            <span class="line-letter-spacing">
              9.上线动员会
            </span>
            <span class="line-letter-spacing">
              10.系统上线试运行
            </span>
          <br/>
            5）持续支持：1.运行支持及优化
            <span class="line-letter-spacing">
            2.项目总结与收尾
            </span>
            <span class="line-letter-spacing">
            3.验收报告
            </span>
        </p> 
      </div>
      <div class="bottom-image">
        <img v-show="imgShow" class="animated slideInLeft" src="@/assets/img/banner_1.png"/>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "page",
  data() {
    return {
      imgShow: false
    }
  },
  methods: {
    onScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if (top >= 180) {
        this.imgShow = true
      } else {
        this.imgShow = false
      }
    }
  },
  mounted(){
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed(){
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss" scoped>
.page {
  // background-color: #ffffff;
   padding: 50px 15px;
}

.line-letter-spacing {
  margin-left: 6px;
}

.page-content {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    height: 100%;
    max-width: 540px;
    display: block;

    .introduction {
      padding: 0px;
      text-align: center;

      .detailed {
        text-align: left;
      }
    }

    .top-image {
      display: none;
    }

    .bottom-image {
      display: block;
      width: 100%;

      .animated {
        width: 100%;
        margin-top: 20px;
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1020px;
  }
}

.introduction {
  padding-left: 30px;
  padding-right: 0px;
  text-align: left;

  .subtitle {
    margin: 0;
    color: #0e314c;
    font-size: 20px;
    font-weight: 500;
  }

  .detailed {
    color: #6084a4;
    line-height: 2;
    font-size: 13px;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .more {
    background-color: #e36cd9;
    box-shadow: 0 13px 27px 0 rgba(244, 134, 101, 0.25);
    color: #ffffff;
    border: none;
    padding: 12px 36px;
    position: relative;
    border-radius: 4px;
    z-index: 1;
    text-transform: uppercase;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    font-weight: 600;
    font-size: 13px;
  }
}

.bottom-image {
  display: none;
}

.image {
  position: relative;
  text-align: center;
  flex: 0 0 42%;
  max-width: 50%;
  padding: 0 30px;
  animation: mymove 5s infinite;
  animation-iteration-count: 1;
  -webkit-animation: mymove 5s infinite; /*Safari and Chrome both*/
  
  @keyframes mymove {
    from {
      top: 0px;
    }

    to {
      top: 200px;
    }
  }
  @-webkit-keyframes mymove /*Safari and Chrome*/ {
    from {
      top: 0px;
    }

    to {
      top: 200px;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>